import { SHARED_ENV } from './environment.shared';

export const environment = {
  ...SHARED_ENV,
  production: true,
  firebase: {
    apiKey: 'AIzaSyCOOCa8mnEAc88g2KWpFl9lMOZgGal1slU',
    authDomain: 'training-bcc46.firebaseapp.com',
    databaseURL: 'https://training-bcc46.firebaseio.com',
    projectId: 'training-bcc46',
    storageBucket: 'training-bcc46.appspot.com',
    messagingSenderId: '538265078064',
    appId: '1:538265078064:web:e2fd8564e84067164c60f5',
    measurementId: 'G-7D0SLS1939'
  },
  mainSystemUrl: 'https://sunip-training.legalsight.com',
  forecasterUrl: 'https://chiefip-training.legalsight.com',
  subscribeKey: 'sub-c-e5233bd6-1abb-11ea-9b6b-ee3e45d53e76',
  local: false,
  raygunKey: '8eS6ffrx62kQYwborG0SKQ==',
  msClarityProjectId: '',
  msClarityEnabled: false,
};
